import './PreventiveExportModal.scss';

import { usePreventiveExport } from "../../hooks/usePreventiveExport";

import FileDownload from "@mui/icons-material/FileDownload";

import { Button } from "../../common-components/Buttons/Buttons";

const PreventiveExportModal = () => {
    const { handleExport } = usePreventiveExport({componentId: "preventive"});

    return (
        <div className={"preventive-export-modal"}>
            <div className={"preventive-export-modal_container"}>
                <div className={"preventive-export-modal_icon"}>
                    <FileDownload sx={{fontSize: "60px"}}/>
                </div>
                <div className={"preventive-export-modal_title"}>
                    {"Экспорт в Excel"}
                </div>
                <div className={"preventive-export-modal_button"}>
                    <Button Icon={FileDownload} title={"Экспорт"} onClick={handleExport}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveExportModal;